import { initAuth } from '@om/shared-auth';

const getRequiredAuthUrl = (): string => {
  const authUrl = import.meta.env.VITE_AUTH_URL?.trim();
  if (!authUrl) {
    throw new Error('Missing VITE_AUTH_URL. Configure the centralized auth portal URL.');
  }

  return authUrl;
};

const getDomainFromUrl = (value?: string): string | undefined => {
  if (!value) return undefined;
  try {
    return new URL(value).origin;
  } catch {
    return undefined;
  }
};

const resolveApiDomain = (): string => {
  const websiteDomain = import.meta.env.VITE_WEBSITE_DOMAIN?.trim();
  const explicitApiDomain = import.meta.env.VITE_SUPERTOKENS_API_DOMAIN || import.meta.env.VITE_API_DOMAIN;
  const apiDomainFromBaseUrl = getDomainFromUrl(import.meta.env.VITE_API_BASE_URL);

  if (!websiteDomain) {
    throw new Error('Missing VITE_WEBSITE_DOMAIN. Configure the organizer website domain.');
  }

  const resolvedApiDomain = explicitApiDomain || apiDomainFromBaseUrl;

  if (!resolvedApiDomain) {
    throw new Error('Missing organizer API domain configuration. Set VITE_API_DOMAIN, VITE_SUPERTOKENS_API_DOMAIN, or VITE_API_BASE_URL.');
  }

  return explicitApiDomain &&
    apiDomainFromBaseUrl &&
    explicitApiDomain === websiteDomain &&
    apiDomainFromBaseUrl !== websiteDomain
    ? apiDomainFromBaseUrl
    : resolvedApiDomain;
};

export const initSupertokens = () => {
  const websiteDomain = import.meta.env.VITE_WEBSITE_DOMAIN?.trim();
  const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN?.trim();

  if (!websiteDomain) {
    throw new Error('Missing VITE_WEBSITE_DOMAIN. Configure the organizer website domain.');
  }

  initAuth({
    appName: import.meta.env.VITE_APP_NAME || 'OM Event Management',
    websiteDomain,
    apiDomain: resolveApiDomain(),
    successRedirectUrl: '/home',
    publicRoutes: ['/', '/auth', '/celebrations/new', '/celebrations/create', '/quick'],
    isProduction: import.meta.env.PROD,
    cookieDomain,
    authRedirectUrl: getRequiredAuthUrl(),
    requireAuthRedirectUrl: true,
  });
};
